import { computed, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { FormGridGroupSections } from '../models/form-grid-group-sections';

@Injectable()
export class FormGridZIndexService {
  private readonly Z_SCALE = 10;

  private readonly groupedSections: WritableSignal<Signal<readonly FormGridGroupSections[]>> = signal(signal([]));

  private readonly zIndices = computed<{
    group: Map<string, number>;
    section: Map<string, { labelZ: number; questionsZ: number }>;
  }>(() => {
    const group = new Map<string, number>();
    const section = new Map<string, { labelZ: number; questionsZ: number }>();
    let i = 0;
    for (const formGroup of this.groupedSections()()) {
      for (const sectionId of formGroup.sectionIds) {
        const questionsZ = this.Z_SCALE * i++;
        const labelZ = this.Z_SCALE * i++;
        section.set(this.sectionZKey(formGroup.type, sectionId), { labelZ, questionsZ });
      }
      group.set(formGroup.type, this.Z_SCALE * i++);
    }
    return { group, section };
  });

  bind(groupedSections: Signal<readonly FormGridGroupSections[]>): void {
    this.groupedSections.set(groupedSections);
  }

  groupZ(formType: string): number {
    return this.zIndices().group.get(formType) ?? 0;
  }

  sectionLabelZ(formType: string, sectionId: string): number {
    return this.zIndices().section.get(this.sectionZKey(formType, sectionId))?.labelZ ?? 0;
  }

  sectionQuestionsZ(formType: string, sectionId: string): number {
    return this.zIndices().section.get(this.sectionZKey(formType, sectionId))?.questionsZ ?? 0;
  }

  private sectionZKey(formType: string, sectionId: string): string {
    return `${formType}|${sectionId}`;
  }
}
